import {
    signOut
} from '../SignIn/actions'
import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    getUserFromToken
} from '../SignIn/actions'
import {
    createAxiosInstance
} from '../../utils/helpers'


export function displayMessages(dispatch, msg) {
    let obj = { type: 'warning', message: '' }
    let message = ''
    if (msg.response) {
        switch (msg.response.status) {
            case 500:
                message = (msg.response.data.ExceptionMessage) ? msg.response.data.ExceptionMessage : msg.response.data.message
                message = message ? message : msg.response.data.Message
                message = message ? message : msg.response.data
                if (message == "Token has expired") {
                    dispatch(signOut())
                } else {
                    dispatch({
                        type: types.LAYOUT_MOSTRAR_MODAL_ERROR,
                        payload: { show: true, message: message }
                    })
                }
                break;
            case 401:
                dispatch({
                    type: types.LAYOUT_MOSTRAR_MENSAJE,
                    payload: {
                        type: 'danger',
                        message: 'No está autorizado para proceder con esta solicitud. Por favor, inicie sesión y vuelva a intentarlo'
                    }
                })
                dispatch(signOut())
                break;
            case 400:
                if (msg.response.data.ModelState) {
                    for (let property in msg.response.data.ModelState) {
                        if (msg.response.data.ModelState.hasOwnProperty(property)) {
                            for (let n = 0; n < msg.response.data.ModelState[property].length; n++) {
                                dispatch({
                                    type: types.LAYOUT_MOSTRAR_MENSAJE,
                                    payload: { type: 'danger', message: msg.response.data.ModelState[property][n] }
                                })
                            }
                        }
                    }
                } else if (msg.response.data.error) {
                    dispatch({
                        type: types.LAYOUT_MOSTRAR_MENSAJE,
                        payload: { type: 'danger', message: msg.response.data.error_description }
                    })
                }
                break;
            case 422:
                if (msg.response.data && msg.response.data.errors) {
                    for (let property in msg.response.data.errors) {
                        if (msg.response.data.errors.hasOwnProperty(property)) {
                            for (let n = 0; n < msg.response.data.errors[property].length; n++) {
                                dispatch({
                                    type: types.LAYOUT_MOSTRAR_MENSAJE,
                                    payload: { type: 'warning', message: msg.response.data.errors[property][n] }
                                })
                            }
                        }
                    }
                }
                break;
            case 405:
                if (msg.response.data.Message) {
                    dispatch({
                        type: types.LAYOUT_MOSTRAR_MODAL_ERROR,
                        payload: {
                            show: true,
                            message: msg.response.data.Message
                        }
                    })
                    //dispatch({type: types.LAYOUT_MOSTRAR_MENSAJE, payload: { type: 'danger', message: msg.response.data.Message }})
                }
                break;

            case 403:
                dispatch({
                    type: types.LAYOUT_MOSTRAR_MENSAJE,
                    payload: {
                        type: 'danger',
                        message: 'Acceso Denegado'
                    }
                })
                break;

            default:

        }
    } else {
        if (msg.data) {
            obj.message = msg.data.Message
            dispatch({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload: obj})
        } else if (msg.message) {
            obj.type = 'danger'
            obj.message = msg.message
            dispatch({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.info) {
            obj.type = 'info'
            obj.message = msg.info
            dispatch({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.success) {
            obj.type = 'success'
            obj.message = msg.success
            dispatch({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload: obj })
        } else if (msg.warning) {
            if (msg.warning instanceof Array) {
                for (let n = 0; n < msg.warning.length; n++) {
                    const payload = { type: 'warning', message: msg.warning[n] }
                    const fn = (d) => d({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload })
                    fn(dispatch)
                }
            } else {
                obj.type = 'warning'
                obj.message = msg.warning
                dispatch({ type: types.LAYOUT_MOSTRAR_MENSAJE, payload: obj })
            }
        } else {
            obj.type = 'danger'
            obj.message = msg
            dispatch({ type: types.LAYOUT_MOSTRAR_MODAL_ERROR, payload: obj })
        }
    }
}

export function clearMessage() {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_LIMPIAR_MENSAJES
        })
    }
}

export function expandCollapseModule(moduloId) {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_EXPANDIR_CONTRAER_MODULO,
            payload: moduloId
        })
    }
}

export function showHideModalMsgBox(show = false, message = null) {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_MOSTRAR_MODAL_ERROR,
            payload: {
                show,
                message
            }
        })
    }
}

export function getUserConfig() {
    return (dispatch) => {
        getUserFromToken()
            .then(data => {
                const fn2 = d => d({
                    type: types.SIGNIN_ASIGNAR_USUARIO_SESION,
                    payload: data
                })
                fn2(dispatch)

                data.modulos.map(x => {
                    return {
                        id: x.cod_nodo,
                        caption: x.nom_modulo,
                        is_active: false,
                        is_open: false,
                        url: x.config.url,
                        subitems: x.submodulos.map(m => {
                            return {
                                id: m.cod_nodo,
                                caption: m.nom_modulo,
                                is_active: false,
                                url: m.config.url,
                                roles: [],
                                visible: true
                            }
                        }),
                        roles: [],
                        visible: true,
                    }
                })
                const fn3 = d => d({
                    type: types.LAYOUT_POBLAR_MODULOS,
                    payload: {
                        modulos: data.modulos,
                        elementos: data.elementos
                    }
                })
                fn3(dispatch)
            })
            .catch(err => {
                if (err.response && err.response.data.status === 401) {
                    dispatch(signOut())
                }
            })
    }
}

export function showModalConfirmAction(open, message = null, action = null) {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_MOSTRAR_MODAL_CONFIRMACION_ACCION,
            payload: {
                open,
                message,
                action
            }
        })
    }
}

export function setSavingState(reducer, value) {
    return (dispatch) => {
        dispatch({
            type: `${reducer.toUpperCase()}_GUARDANDO`,
            payload: value
        })
    }
}

export function showHideModalSelector(show, title, model, fields, action, include, filters = []) {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_MOSTRAR_MODAL_SELECTOR,
            payload: {
                show,
                title,
                fields,
                model,
                action,
                include,
                filters
            }
        })
        if (show) dispatch(getDataFromServer())
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch({
            type: types.LAYOUT_MOSTRAR_LOADING_SELECTOR,
            payload: true
        })

        const modelo = getState().layout.getIn(['modalSelector', 'model'])
        const include = getState().layout.getIn(['modalSelector', 'include'])
        const pages = getState().layout.getIn(['modalSelector', 'pages'])
        const take = getState().layout.getIn(['modalSelector', 'take'])
        const filter = getState().layout.getIn(['modalSelector', 'filter'])
        const fields = getState().layout.getIn(['modalSelector', 'fields'])
        const filters = getState().layout.getIn(['modalSelector', 'filters']).toJS()

        if (filter) {
            fields.forEach(x => {
                let f = {
                    group: {
                        id: 9999,
                        glue: 'and'
                    },
                    field: x.get('value'),
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }

        let url = "list"
        if (modelo === 'Cenco') url = 'cencos/list'
        const skip = (page - 1) * take

        if (pages.filter(x => x === page).count() < 1) {
            dispatch({
                type: types.LAYOUT_MODIFICAR_PAGINA_MODAL_SELECTOR,
                payload: {
                    page
                }
            })
            axios.post(`${API_URL}/${url}`, {
                    modelo,
                    filters,
                    include,
                    skip,
                    take
                })
                .then((res) => {
                    const list = res.data
                    dispatch({
                        type: types.LAYOUT_ACTUALIZAR_LISTADO_SELECTOR,
                        payload: {
                            list
                        }
                    })
                    dispatch({
                        type: types.LAYOUT_MOSTRAR_LOADING_SELECTOR,
                        payload: false
                    })
                })
                .catch((err) => {
                    dispatch({
                        type: types.LAYOUT_MOSTRAR_LOADING_SELECTOR,
                        payload: false
                    })
                    displayMessages(dispatch, err)
                })
        } else {
            dispatch({
                type: types.LAYOUT_MOSTRAR_LOADING_SELECTOR,
                payload: false
            })
        }
    }
}

export function clearPagesModalSelector() {
    return (dispatch) => {
        dispatch({
            type: types.LAYOUT_REINICIAR_LISTA_MODAL_SELECTOR
        })
    }
}

export function addTitleIfOverflow(element) {
    if (element.offsetWidth <= element.scrollWidth && !element.hasAttribute('title')) {
        element.setAttribute('title', element.innerHTML)
    }
}

export function selectFromSelector(payload) {
    return (dispatch) => {
        dispatch({
            type: 'HYQ3_MODIFY_INPUT_VALUE',
            payload
        })
    }
}